import { SVGProps, Ref, forwardRef } from 'react';

export const ClocheFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M13.75 1a1.15 1.15 0 0 1 0 2.3h-.85v3.916c2.951.1 5.398.72 7.012 2.277 1.822 1.756 2.347 4.456 1.777 8.08-.332 2.114.202 2.936.55 3.258a1.45 1.45 0 0 0 .759.365l.027.003H24V23H0v-1.8h.975l.027-.004a1.451 1.451 0 0 0 .759-.365c.348-.322.882-1.144.55-3.259-.57-3.623-.045-6.323 1.777-8.079 1.614-1.556 4.06-2.177 7.012-2.277V3.3h-.85a1.15 1.15 0 0 1-1.145-1.033L9.1 2.15l.005-.117A1.15 1.15 0 0 1 10.25 1z"
            fill="currentColor"
        />
    </svg>
));
ClocheFilledSize24Glyph.displayName = 'ClocheFilledSize24Glyph';
